module.exports = __webpack_public_path__ + "static/media/Macbook3.8a7bda0e.png";